class Location {
	normalize = data => {
		const { assetInfo } = data;
    	const props = assetInfo?.metadata?.props || data;
		const nodeName = data.nodeName;
		return {
			id: data.nodeAddress,
			areaId: props.areaId,
			areaName: props.areaName || 'N/A',
			siteId: props.siteId,
			siteName: props.siteName || 'N/A',
			value: props.name ? props.name : nodeName || 'N/A',
			name: data.nodeName || props.name || 'N/A',
			macAddress: props.macAddress,
			point: props.mapPoint ? props.mapPoint.split(',').map(Number) : [],
			checked: false,
			zoneId: props.zoneId,
			zoneName: props.zoneName,
			lastProvisioned: props.lastProvisioned,
			unprovisionedTime: props.unprovisionedTime,
			installedLatitude: props.installedLatitude ? props.installedLatitude : null,
			installedLongitude: props.installedLongitude ? props.installedLongitude : null,
			installationPictureId: props.installationPictureId,
			locationPictureId: props.locationPictureId,
			otherPictureId: props.otherPictureId,
			lastAf3EventTime: props.t_ingest ? new Date(parseInt(props.t_ingest)) : null,
			latitude: props.latitude && +props.latitude,
			longitude: props.longitude && +props.longitude,
			xCoordinate: props.xCoordinate,
			yCoordinate: props.yCoordinate,
			zCoordinate: props.zCoordinate
		};
	};
}

export default Location;